/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { EnSessionEventView } from './en-session-event-view';
 /**
 *
 *
 * @export
 * @interface ReadSessionEventParamsDto
 */
export interface ReadSessionEventParamsDto {

    /**
     * When true returns only soft-deleted rows. When omitted or false, only live rows. Restore-by-id is unchanged.
     *
     * @type {boolean}
     * @memberof ReadSessionEventParamsDto
     */
    deleted?: boolean;

    /**
     * When true returns { data, meta } paginated response. When false (default) returns a plain array of all matching records ignoring page/limit.
     *
     * @type {boolean}
     * @memberof ReadSessionEventParamsDto
     */
    paginated?: boolean;

    /**
     * Page number (1-based)
     *
     * @type {number}
     * @memberof ReadSessionEventParamsDto
     * @example 1
     */
    page?: number;

    /**
     * Filter by template status. When omitted, no template filter is applied.
     *
     * @type {boolean}
     * @memberof ReadSessionEventParamsDto
     */
    isTemplate?: boolean;

    /**
     * Number of records per page
     *
     * @type {number}
     * @memberof ReadSessionEventParamsDto
     * @example 10
     */
    limit?: number;

    /**
     * Response shape. Omit for the full `SessionEventDto` graph; `calendar` for the flat `CalendarEventDto[]` projection (no nested session / exercise / profile data). Same start/end filter either way.
     *
     * @type {EnSessionEventView}
     * @memberof ReadSessionEventParamsDto
     */
    view?: EnSessionEventView;

    /**
     * @type {string}
     * @memberof ReadSessionEventParamsDto
     * @example start
     */
    sortBy?: ReadSessionEventParamsDtoSortByEnum;

    /**
     * Sort direction
     *
     * @type {string}
     * @memberof ReadSessionEventParamsDto
     */
    sortDirection?: ReadSessionEventParamsDtoSortDirectionEnum;

    /**
     * @type {string}
     * @memberof ReadSessionEventParamsDto
     */
    date?: string;

    /**
     * @type {string}
     * @memberof ReadSessionEventParamsDto
     */
    start?: string;

    /**
     * @type {string}
     * @memberof ReadSessionEventParamsDto
     */
    end?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum ReadSessionEventParamsDtoSortByEnum {
    Start = 'start',
    End = 'end',
    Created = 'created'
}
/**
 * @export
 * @enum {string}
 */
export enum ReadSessionEventParamsDtoSortDirectionEnum {
    ASC = 'ASC',
    DESC = 'DESC'
}

